<template>
  <div class="w-full">
    <label for="phone-input" class="block text-sm font-medium leading-6" :class="[$theme.baseTextColor]">
      {{ t('phone') }}
    </label>
    <div class="mt-2 relative">
      <input
          type="tel"
          id="phone-input"
          ref="phoneInput"
          class="block w-full rounded-full border-0 py-2 ring-0 ring-inset focus:ring-1 focus:ring-inset"
          :class="[
              $theme.baseTextColor,
              $theme.inputPlaceTextColor,
              $theme.inputRingFocusColor,
              $theme.inputBorderColor,
              $theme.inputRingColor,
              $theme.inputBg,
            ]"
          :placeholder="t('enter_phone')"
          @input="validatePhone"
      />
      <CheckCircleIcon v-if="isValidPhone" class="absolute top-2.5 right-2 w-5 h-5" :class="[$theme.successPnlColor]" />
    </div>
    <div v-if="errorMessage" class="text-sm mt-2" :class="[$theme.dangerPnlColor]">{{ errorMessage }}</div>
  </div>
</template>

<script setup>
import { ref, onMounted, defineEmits } from 'vue'
import axios from 'axios'
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'
import { useI18n } from 'vue-i18n'
import { CheckCircleIcon } from '@heroicons/vue/20/solid'

const emit = defineEmits(['update:modelValue'])
const phoneInput = ref(null)
const errorMessage = ref('')
const isValidPhone = ref(false)
let iti = null

const { t } = useI18n()

onMounted(() => {
  iti = intlTelInput(phoneInput.value, {
    initialCountry: 'auto',
    geoIpLookup: function (callback) {
      axios.get('https://ipinfo.io?token=b0f135e3aa6709')
          .then(resp => {
            const countryCode = resp.data.country
            callback(countryCode)
          })
          .catch(() => {
            callback('us')
          })
    },
    utilsScript: '/utils/telUtils.js',
    separateDialCode: true,
    nationalMode: false,
  })
})

// Функция для динамической проверки
const validatePhone = () => {
  if (iti.isValidNumber()) {
    emit('update:modelValue', iti.getNumber())
    errorMessage.value = ''
    isValidPhone.value = true
  } else {
    errorMessage.value = t('invalid_phone')
    isValidPhone.value = false
  }
}
</script>
